import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaPhone, FaEnvelope, FaInstagram } from 'react-icons/fa';
import './Footer.css';
import logo from '../assets/odmaralistehana-logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img 
              src={logo} 
              alt="Odmaralište Hana Logo" 
              className="footer-logo-img" 
            />
            <h3>Odmaralište Hana</h3>
            <p>Ugodno mjesto za vaš odmor i uživanje</p>
          </div>
          
          <div className="footer-links">
            <h4>Brzi linkovi</h4>
            <ul>
              <li><Link to="/gallery">Galerija</Link></li>
              <li><Link to="/location">Lokacija</Link></li>
              <li><Link to="/contact">Kontakt</Link></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h4>Kontaktirajte nas</h4>
            <div className="footer-contact-item">
              <FaPhone className="footer-icon" />
              <span>+387 61 289290</span>
            </div>
            <div className="footer-contact-item">
              <FaEnvelope className="footer-icon" />
              <span>info@odmaralistehana.ba</span>
            </div>
            <div className="footer-social">
              <a 
                href="https://www.facebook.com/profile.php?id=61576862631693" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaFacebook />
              </a>
              <a 
                href="https://www.instagram.com/odmaralistehana" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Odmaralište Hana. Sva prava pridržana.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
